<template>
  <div>
    <DeniedRequests/>
  </div>
</template>
  
  <script>
  // @ is an alias to /src
  import DeniedRequests from '@/components/DeniedRequests.vue'
  
  export default {
    name: 'penidng-approval-view',
    components: {
      DeniedRequests
    }
  }
  </script>
  